import { render } from "./MenuSortingList.vue?vue&type=template&id=0940ee06&scoped=true"
import script from "./MenuSortingList.vue?vue&type=script&lang=js"
export * from "./MenuSortingList.vue?vue&type=script&lang=js"

import "./MenuSortingList.vue?vue&type=style&index=0&id=0940ee06&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0940ee06"]])

export default __exports__